import { IncomingContent } from '@/data/types/IncomingContent';
import { Layout } from '@/data/types/Layout';

export const getElectronicsPage = (_: IncomingContent): Layout => ({
	name: 'HomeStack',
	slots: {
		header: [{ name: 'Header', id: 'header' }],
		first: [{ name: 'Electronics', id: 'electronics'}],
		second: [],
		footer: [{ name: 'Footer', id: 'footer' }],
	},
});
